/* =========================================================
   HAUNTED — Halloween Shopify Theme
   Main JavaScript
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {
  initMobileNav();
  initCartCount();
  initVariantSelectors();
  initQuantitySelectors();
  initAddToCartForms();
  initProductThumbnails();
  initSmoothScroll();
});

/* ---------------------------------------------------------
   Mobile nav toggle
   --------------------------------------------------------- */
function initMobileNav() {
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', function () {
    nav.classList.toggle('is-open');
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
  });
}

/* ---------------------------------------------------------
   Cart count — fetch /cart.js and update nav bubble
   --------------------------------------------------------- */
function initCartCount() {
  updateCartCount();
}

function updateCartCount() {
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      var bubbles = document.querySelectorAll('[data-cart-count]');
      bubbles.forEach(function (bubble) {
        bubble.textContent = cart.item_count;
        bubble.hidden = cart.item_count === 0;
      });
    })
    .catch(function (err) {
      console.warn('Haunted theme: could not fetch cart', err);
    });
}

/* ---------------------------------------------------------
   Variant selection + price update
   --------------------------------------------------------- */
function initVariantSelectors() {
  var forms = document.querySelectorAll('[data-product-form]');

  forms.forEach(function (form) {
    var swatches = form.querySelectorAll('[data-variant-swatch]');
    var variantInput = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-product-price]');
    var comparePriceEl = form.querySelector('[data-product-compare-price]');

    var variantsJsonEl = form.querySelector('[data-product-variants]');
    var variants = [];
    if (variantsJsonEl) {
      try {
        variants = JSON.parse(variantsJsonEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('is-selected'); });
        swatch.classList.add('is-selected');

        var variantId = swatch.getAttribute('data-variant-id');
        if (variantInput) variantInput.value = variantId;

        var variant = variants.filter(function (v) {
          return String(v.id) === String(variantId);
        })[0];

        if (variant && priceEl) {
          priceEl.textContent = formatMoney(variant.price);
        }
        if (variant && comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = formatMoney(variant.compare_at_price);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
      });
    });
  });
}

function formatMoney(cents) {
  var value = (cents / 100).toFixed(2);
  return '$' + value;
}

/* ---------------------------------------------------------
   Quantity selectors
   --------------------------------------------------------- */
function initQuantitySelectors() {
  var selectors = document.querySelectorAll('[data-quantity-selector]');

  selectors.forEach(function (selector) {
    var input = selector.querySelector('input[type="number"]');
    var decrement = selector.querySelector('[data-quantity-decrement]');
    var increment = selector.querySelector('[data-quantity-increment]');

    if (decrement) {
      decrement.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, value - 1);
      });
    }

    if (increment) {
      increment.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 1;
        input.value = value + 1;
      });
    }
  });
}

/* ---------------------------------------------------------
   Add to cart — AJAX submit with mini feedback
   --------------------------------------------------------- */
function initAddToCartForms() {
  var forms = document.querySelectorAll('form[action^="/cart/add"]');

  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.textContent = 'ADDING...';
        submitBtn.disabled = true;
      }

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (submitBtn) {
            submitBtn.textContent = 'ADDED ✓';
          }
          updateCartCount();
          setTimeout(function () {
            if (submitBtn) {
              submitBtn.textContent = originalText;
              submitBtn.disabled = false;
            }
          }, 1500);
        })
        .catch(function (err) {
          console.warn('Haunted theme: add to cart failed', err);
          if (submitBtn) {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }
        });
    });
  });

  /* Quick-add buttons on product cards */
  var quickAddButtons = document.querySelectorAll('[data-quick-add]');
  quickAddButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          updateCartCount();
          button.classList.add('is-added');
          setTimeout(function () {
            button.classList.remove('is-added');
          }, 1200);
        })
        .catch(function (err) {
          console.warn('Haunted theme: quick add failed', err);
        });
    });
  });
}

/* ---------------------------------------------------------
   Product page thumbnails
   --------------------------------------------------------- */
function initProductThumbnails() {
  var thumbs = document.querySelectorAll('[data-product-thumb]');
  var mainImage = document.querySelector('[data-product-main-image]');
  if (!thumbs.length || !mainImage) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var newSrc = thumb.getAttribute('data-full-src');
      if (newSrc) {
        mainImage.setAttribute('src', newSrc);
      }
    });
  });
}

/* ---------------------------------------------------------
   Smooth scroll for in-page anchors
   --------------------------------------------------------- */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href');
      if (targetId.length < 2) return;
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
}
